import { render } from "./LegislationBackBtn.vue?vue&type=template&id=19cfcc69"
import script from "./LegislationBackBtn.vue?vue&type=script&lang=js"
export * from "./LegislationBackBtn.vue?vue&type=script&lang=js"

import "./LegislationBackBtn.vue?vue&type=style&index=0&id=19cfcc69&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__